import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTheme } from './ThemeContext';
import { NAV_LINKS, STUDIO } from '../data/siteContent';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { theme, toggle } = useTheme();
  const { pathname } = useLocation();

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', fn, { passive: true }); fn();
    return () => window.removeEventListener('scroll', fn);
  }, []);

  useEffect(() => { setOpen(false); }, [pathname]);

  return (
    <>
      <nav className={`navbar${scrolled ? ' scrolled' : ''}`} data-testid="navbar">
        <div className="wrap">
          <Link to="/" className="nav-brand" data-testid="nav-brand">
            <div className="dot"></div>
            <span>{STUDIO.name}</span>
          </Link>

          <div className="nav-links">
            {NAV_LINKS.map(({ to, label }) => (
              <Link key={to} to={to} className={`nav-link${pathname === to ? ' active' : ''}`}>{label}</Link>
            ))}
          </div>

          <div className="nav-right">
            <button className="theme-btn" onClick={toggle} aria-label="Toggle theme" data-testid="theme-toggle">
              <i className={`fas fa-${theme === 'dark' ? 'sun' : 'moon'}`}></i>
            </button>
          </div>
          <button
            className={`hamburger${open ? ' open' : ''}`}
            onClick={() => setOpen(o => !o)}
            aria-label="Menu"
            aria-expanded={open}
            aria-controls="nav-drawer"
            data-testid="hamburger"
          >
            <span></span><span></span><span></span>
          </button>
        </div>
      </nav>

      <div id="nav-drawer" className={`nav-drawer${open ? ' open' : ''}`} data-testid="nav-drawer">
        {NAV_LINKS.map(({ to, label }) => (
          <Link key={to} to={to} className={`nav-link${pathname === to ? ' active' : ''}`}>{label}</Link>
        ))}
        <div style={{ marginTop: 'auto', display: 'flex', flexDirection: 'column', gap: 10 }}>
          <button className="theme-btn" onClick={toggle} style={{ width: '100%', borderRadius: 12, height: 44 }}>
            <i className={`fas fa-${theme === 'dark' ? 'sun' : 'moon'}`}></i>
            &nbsp; Switch to {theme === 'dark' ? 'Light' : 'Dark'} Mode
          </button>
        </div>
      </div>
    </>
  );
}
